import React, { useState } from 'react';

import { filter, size } from 'lodash';

import { column } from '@/config/myMusicTable.config';
import { myMusicHelpers } from '@/helpers';
import { AppSkeleton, MusicPlayer, Table } from '@/component';
import { Input } from '@/kaya';
import { musicPlayerStore, songsStore } from '@/store';
import Icons from '@/icons';
import { iconConstants } from '@/constants';
import { songTypes } from '@/types';

import styles from './MyMusic.module.scss';

const MyMusic = () => {
  const { songs } = songsStore();
  const { setMusic } = musicPlayerStore();

  const [search, setSearch] = useState('');

  const handleRowClick = async (item: songTypes.Song) => {
    setMusic(item);
  };

  const acceptedSongData = filter(songs, (item: any) => item.submission_status === 'ACCEPTED');

  return (
    <AppSkeleton ChildclassName={styles.MymusicClass}>
      <div className={styles.MyMusic}>
        <Input
          placeholder="Find your music"
          width="100%"
          prefixIcon={<Icons type={iconConstants.ICONS.SEARCH_ICON} />}
          onChange={setSearch}
        />
        <p className={styles.header}>My Music</p>
      </div>
      <div
        // style={{ height: 'calc(100vh - 288px)', paddingLeft: 40, paddingRight: 40 }}
        className={styles.tableWrapper}
      >
        <Table
          columns={column}
          rows={myMusicHelpers.searchResult(songs, search)}
          disableActions
          handleRowClick={handleRowClick}
        />
      </div>

      {size(acceptedSongData) > 0 && <MusicPlayer />}
    </AppSkeleton>
  );
};

export default MyMusic;
